import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  Icon,
  FormField,
  Dropdown,
  Input,
  Radio,
  Button,
  TextArea
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Calendar
} from 'react-big-calendar'

const ModPlanningUX = (props: any) => {
    return(
      <div
        id="ModPlanningUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          id="ModPlanningUX-div-142"
          style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

          <div
            id="ModPlanningUX-div-143"
            style={{fontSize: "1.15rem", fontWeight: "bold", padding: "2.5px 0"}}>
            {props.planSummary}
          </div>
          <div
            id="ModPlanningUX-div-144"
            style={{cursor: "pointer"}}>

            <Icon
              className="red"
              id="ModPlanningUX-Icon-145"
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          className="ui divider"
          id="ModPlanningUX-div-146">

        </div>
        <div
          className="ui form --override-disabled"
          id="ModPlanningUX-div-139"
          style={{padding: "0 0.5rem"}}>

          <FormGroup
            id="ModPlanningUX-FormGroup-140"
            inline={true}>
            <FormField
              id="ModPlanningUX-FormField-148"
              inline={true}
              width={8}>
              <label
                id="ModPlanningUX-label-149"
                style={{minWidth: "80px", maxWidth: "80px", paddingLeft: "1.65rem", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "type" : "ประเภท"}
              </label>
              <Dropdown
                fluid={true}
                id="ModPlanningUX-Dropdown-150"
                name="type"
                onChange={props.onChangePlanningData }
                options={[ {key: 1, value: "NORMAL", text: "ปกติ"}, {key: 2, value: "CUSTOM", text: "เลือกเอง"} ]}
                selection={true}
                style={{width: "100%"}}
                value={props.planningData?.type || "NORMAL"}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-141"
            inline={true}
            style={{display: props.planningData?.type !== "CUSTOM" ? "" : "none" }}>
            <FormField
              id="ModPlanningUX-FormField-151"
              inline={true}
              width={5}>
              <label
                id="ModPlanningUX-label-152"
                style={{minWidth: "80px", maxWidth: "80px", paddingLeft: "1.65rem", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "start" : "เริ่มต้น"}
              </label>
              <div
                id="ModPlanningUX-div-153"
                style={{width: "100%"}}>

                <DateTextBox
                  id="ModPlanningUX-DateTextBox-154"
                  minDate={props.today}
                  onChange={props.onChangePlanningStartDate}
                  value={props.planningData?.start_date}>
                </DateTextBox>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-155"
            inline={true}
            style={{display: props.planningData?.type !== "CUSTOM" ? "" : "none" }}>
            <FormField
              id="ModPlanningUX-FormField-156"
              inline={true}
              width={8}>
              <Radio
                checked={props.planningData?.scheduleType === "day"}
                id="ModPlanningUX-Radio-202"
                label={props.languageUX === "en" ? "Repeat" : "ทำซ้ำ"}
                onChange={props.onChangeRadio}
                style={{minWidth: "80px", maxWidth: "80px", fontSize: ".92857143em"}}
                value="day">
              </Radio>
              <Input
                action="วัน"
                disabled={props.planningData?.scheduleType !== "day"}
                fluid={true}
                id="ModPlanningUX-Input-160"
                name="day_take"
                onChange={props.onChangePlanningData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                placeholder="ระบุตัวเลข"
                type="number"
                value={props.planningData?.day_take}>
              </Input>
            </FormField>
            <FormField
              id="ModPlanningUX-FormField-157"
              inline={true}
              width={8}>
              <label
                id="ModPlanningUX-label-159"
                style={{minWidth: "80px", maxWidth: "80px", textAlign: "right", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Except" : "เว้น"}
              </label>
              <Input
                action="วัน"
                disabled={props.planningData?.scheduleType !== "day"}
                fluid={true}
                id="ModPlanningUX-Input-161"
                name="day_skip"
                onChange={props.onChangePlanningData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                placeholder="ระบุตัวเลข"
                type="number"
                value={props.planningData?.day_skip}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-162"
            inline={true}
            style={{display: props.planningData?.type !== "CUSTOM" ? "" : "none" }}>
            <FormField
              id="ModPlanningUX-FormField-163"
              inline={true}
              width={16}>
              <Radio
                checked={props.planningData?.scheduleType === "week_days"}
                id="ModPlanningUX-Radio-203"
                label={props.languageUX === "en" ? "On the day" : "ในวัน"}
                onChange={props.onChangeRadio}
                style={{minWidth: "80px", maxWidth: "80px", fontSize: ".92857143em"}}
                value="week_days">
              </Radio>
              <Dropdown
                disabled={props.planningData?.scheduleType !== "week_days"}
                fluid={true}
                id="ModPlanningUX-Dropdown-165"
                multiple={true}
                name="week_days"
                onChange={props.onChangePlanningData}
                options={[ {key: 1, value: "Mon", text: "จันทร์"}, { key: 2, value: "Tue", text: "อังคาร" }, {key: 3, value: "Wed", text: "พุธ"}, { key: 4, value: "Thu", text: "พฤหัสบดี" }, {key: 5, value: "Fri", text: "ศุกร์"}, { key: 6, value: "Sat", text: "เสาร์" }, {key: 7, value: "Sun", text: "อาทิตย์"} ]}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.planningData?.week_days}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-166"
            inline={true}
            style={{display: props.planningData?.type !== "CUSTOM" ? "" : "none" }}>
            <FormField
              id="ModPlanningUX-FormField-167"
              inline={true}
              width={16}>
              <label
                id="ModPlanningUX-label-168"
                style={{minWidth: "80px", maxWidth: "80px",paddingLeft: "1.65rem", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "end" : "สิ้นสุด"}
              </label>
              <Radio
                checked={!["OCCURRENCE", "END_DATE"].includes(props.planningData?.endDate)}
                id="ModPlanningUX-Radio-172"
                label={props.languageUX === "en" ? "do not have" : "ไม่มี"}
                name="endDate"
                onChange={props.onChangePlanningData}
                value="NONE">
              </Radio>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-170"
            inline={true}
            style={{display: props.planningData?.type !== "CUSTOM" ? "" : "none" }}>
            <FormField
              id="ModPlanningUX-FormField-173"
              inline={true}
              style={{minWidth: "max-content"}}>
              <label
                id="ModPlanningUX-label-176"
                style={{minWidth: "80px", maxWidth: "80px",}}>

              </label>
              <Radio
                checked={props.planningData?.endDate === "OCCURRENCE"}
                id="ModPlanningUX-Radio-177"
                label={props.languageUX === "en" ? "After it happened" : "หลังจากเกิดขึ้น"}
                name="endDate"
                onChange={props.onChangePlanningData}
                style={{minWidth: "120px", maxWidth: "120px"}}
                value="OCCURRENCE">
              </Radio>
            </FormField>
            <FormField
              id="ModPlanningUX-FormField-179"
              inline={true}
              width={16}>
              <Input
                action="วัน"
                disabled={props.planningData?.endDate !== "OCCURRENCE"}
                fluid={true}
                id="ModPlanningUX-Input-180"
                name="occurrence"
                onChange={props.onChangePlanningData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.planningData?.occurrence}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-171"
            inline={true}
            style={{display: props.planningData?.type !== "CUSTOM" ? "" : "none" }}>
            <FormField
              id="ModPlanningUX-FormField-174"
              inline={true}
              style={{minWidth: "max-content"}}>
              <label
                id="ModPlanningUX-label-175"
                style={{minWidth: "80px", maxWidth: "80px",}}>

              </label>
              <Radio
                checked={props.planningData?.endDate === "END_DATE"}
                id="ModPlanningUX-Radio-178"
                label={props.languageUX === "en" ? "On the day" : "ในวันที่"}
                name="endDate"
                onChange={props.onChangePlanningData}
                style={{minWidth: "120px", maxWidth: "120px"}}
                value="END_DATE">
              </Radio>
            </FormField>
            <FormField
              id="ModPlanningUX-FormField-181"
              inline={true}
              width={4}>
              <div
                id="ModPlanningUX-div-182"
                style={{width: "100%"}}>

                <DateTextBox
                  disabled={props.planningData?.endDate !== "END_DATE"}
                  id="ModPlanningUX-DateTextBox-183"
                  minDate="props.today"
                  onChange={props.onChangePlanningEndDate}
                  value={props.planningData?.end_date}>
                </DateTextBox>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-195"
            style={{display: props.planningData?.type === "CUSTOM" ? "" : "none",  }}>
            <FormField
              id="ModPlanningUX-FormField-196"
              width={16}>
              <div
                id="ModPlanningUX-div-200"
                style={{width: "100%", height: "13rem"}}>

                <Calendar
                  events={props.planningData?.dates || []}
                  id="ModPlanningUX-Calendar-201"
                  localizer={props.calendarLocalizer}
                  min={new Date()}
                  onNavigate={props.onCalendarNavigate}
                  views={["month"]}>
                </Calendar>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="ModPlanningUX-FormGroup-197"
            style={{display: props.planningData?.type === "CUSTOM" ? "" : "none",  }}>
            <FormField
              id="ModPlanningUX-FormField-198"
              width={16}>
              <TextArea
                disabled={true}
                id="ModPlanningUX-TextArea-199"
                style={{ width: "100%", textAlign: "center" }}
                value={props.planningData?.dates?.join('\n')}>
              </TextArea>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="ModPlanningUX-div-184"
          style={{ padding: "5px", textAlign: "center", border: "solid 1px rgb(200, 200, 200, 0.5)", margin: "1.5rem 0.5rem 0"}}>
          {props.planningData?.date_time_summary}
        </div>
        <div
          className="ui form"
          id="ModPlanningUX-div-185"
          style={{marginTop: "1rem"}}>

          <FormGroup
            id="ModPlanningUX-FormGroup-186"
            inline={true}>
            <FormField
              id="ModPlanningUX-FormField-187"
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="ModPlanningUX-FormField-188"
              style={{padding: 0, display: "flex"}}>
              <Button
                color="green"
                id="ModPlanningUX-Button-189"
                onClick={props.onRequestPlanning}
                size="small"
                style={{ display: props.planningData?.allowed_actions?.includes("REQUEST") ? "" : "none" }}>
                {props.languageUX === "en" ? "OK" : "ตกลง"}
              </Button>
              <div
                id="ModPlanningUX-div-190">
                {props.buttonEdit}
              </div>
              <div
                id="ModPlanningUX-div-191">
                {props.buttonResume}
              </div>
              <div
                id="ModPlanningUX-div-192">
                {props.buttonOff}
              </div>
              <div
                id="ModPlanningUX-div-193">
                {props.buttonHold}
              </div>
              <div
                id="ModPlanningUX-div-194">
                {props.buttonRenew}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default ModPlanningUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 18:02:40 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 0.5rem\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type !== \"CUSTOM\" ? \"\" : \"none\" }"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "code",
          "value": "props.planSummary"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-143"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\", padding: \"2.5px 0\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Icon",
      "parent": 144,
      "props": {
        "className": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Icon-145"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-146"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "label",
      "parent": 148,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท",
          "valueEN": "type"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-label-149"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\", paddingLeft: \"1.65rem\", fontWeight: \"normal\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "Dropdown",
      "parent": 148,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Dropdown-150"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData "
        },
        "options": {
          "type": "code",
          "value": "[ {key: 1, value: \"NORMAL\", text: \"ปกติ\"}, {key: 2, value: \"CUSTOM\", text: \"เลือกเอง\"} ]"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.type || \"NORMAL\""
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-151"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "label",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "เริ่มต้น",
          "valueEN": "start"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-label-152"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\", paddingLeft: \"1.65rem\", fontWeight: \"normal\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 154,
      "name": "DateTextBox",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-DateTextBox-154"
        },
        "minDate": {
          "type": "code",
          "value": "props.today"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.start_date"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-155"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type !== \"CUSTOM\" ? \"\" : \"none\" }"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 155,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-156"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 155,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "label",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": "เว้น",
          "valueEN": "Except"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-label-159"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\", textAlign: \"right\", fontWeight: \"normal\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Input",
      "parent": 156,
      "props": {
        "action": {
          "type": "value",
          "value": "วัน"
        },
        "disabled": {
          "type": "code",
          "value": "props.planningData?.scheduleType !== \"day\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Input-160"
        },
        "name": {
          "type": "value",
          "value": "day_take"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "placeholder": {
          "type": "value",
          "value": "ระบุตัวเลข"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.day_take"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "Input",
      "parent": 157,
      "props": {
        "action": {
          "type": "value",
          "value": "วัน"
        },
        "disabled": {
          "type": "code",
          "value": "props.planningData?.scheduleType !== \"day\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Input-161"
        },
        "name": {
          "type": "value",
          "value": "day_skip"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "placeholder": {
          "type": "value",
          "value": "ระบุตัวเลข"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.day_skip"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-162"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type !== \"CUSTOM\" ? \"\" : \"none\" }"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "FormField",
      "parent": 162,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-163"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Dropdown",
      "parent": 163,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.planningData?.scheduleType !== \"week_days\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Dropdown-165"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "week_days"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "options": {
          "type": "code",
          "value": "[ {key: 1, value: \"Mon\", text: \"จันทร์\"}, { key: 2, value: \"Tue\", text: \"อังคาร\" }, {key: 3, value: \"Wed\", text: \"พุธ\"}, { key: 4, value: \"Thu\", text: \"พฤหัสบดี\" }, {key: 5, value: \"Fri\", text: \"ศุกร์\"}, { key: 6, value: \"Sat\", text: \"เสาร์\" }, {key: 7, value: \"Sun\", text: \"อาทิตย์\"} ]"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.week_days"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type !== \"CUSTOM\" ? \"\" : \"none\" }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormField",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "label",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "สิ้นสุด",
          "valueEN": "end"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-label-168"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",paddingLeft: \"1.65rem\", fontWeight: \"normal\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-170"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type !== \"CUSTOM\" ? \"\" : \"none\" }"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-171"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type !== \"CUSTOM\" ? \"\" : \"none\" }"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "Radio",
      "parent": 167,
      "props": {
        "checked": {
          "type": "code",
          "value": "![\"OCCURRENCE\", \"END_DATE\"].includes(props.planningData?.endDate)"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Radio-172"
        },
        "label": {
          "type": "value",
          "value": "ไม่มี",
          "valueEN": "do not have"
        },
        "name": {
          "type": "value",
          "value": "endDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "value": {
          "type": "value",
          "value": "NONE"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "FormField",
      "parent": 170,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-173"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "FormField",
      "parent": 171,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-174"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "label",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-label-175"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "label",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-label-176"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\",}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "Radio",
      "parent": 173,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.planningData?.endDate === \"OCCURRENCE\""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Radio-177"
        },
        "label": {
          "type": "value",
          "value": "หลังจากเกิดขึ้น",
          "valueEN": "After it happened"
        },
        "name": {
          "type": "value",
          "value": "endDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        },
        "value": {
          "type": "value",
          "value": "OCCURRENCE"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Radio",
      "parent": 174,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.planningData?.endDate === \"END_DATE\""
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Radio-178"
        },
        "label": {
          "type": "value",
          "value": "ในวันที่",
          "valueEN": "On the day"
        },
        "name": {
          "type": "value",
          "value": "endDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        },
        "value": {
          "type": "value",
          "value": "END_DATE"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "FormField",
      "parent": 170,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-179"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "Input",
      "parent": 179,
      "props": {
        "action": {
          "type": "value",
          "value": "วัน"
        },
        "disabled": {
          "type": "code",
          "value": "props.planningData?.endDate !== \"OCCURRENCE\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Input-180"
        },
        "name": {
          "type": "value",
          "value": "occurrence"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.occurrence"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormField",
      "parent": 171,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-181"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 183,
      "name": "DateTextBox",
      "parent": 182,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.planningData?.endDate !== \"END_DATE\""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-DateTextBox-183"
        },
        "minDate": {
          "type": "value",
          "value": "props.today"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePlanningEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.end_date"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.planningData?.date_time_summary"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-184"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\", textAlign: \"center\", border: \"solid 1px rgb(200, 200, 200, 0.5)\", margin: \"1.5rem 0.5rem 0\"}"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-185"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "FormGroup",
      "parent": 185,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-186"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 186,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-187"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 186,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-188"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0, display: \"flex\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "Button",
      "parent": 188,
      "props": {
        "children": {
          "type": "value",
          "value": "ตกลง",
          "valueEN": "OK"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Button-189"
        },
        "onClick": {
          "type": "code",
          "value": "props.onRequestPlanning"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.planningData?.allowed_actions?.includes(\"REQUEST\") ? \"\" : \"none\" }",
          "valueEN": ""
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEdit"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-190"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonResume"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-191"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonOff"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-192"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonHold"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-193"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRenew"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-194"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-195"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type === \"CUSTOM\" ? \"\" : \"none\",  }"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormField",
      "parent": 195,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-196"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormGroup-197"
        },
        "style": {
          "type": "code",
          "value": "{display: props.planningData?.type === \"CUSTOM\" ? \"\" : \"none\",  }"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "FormField",
      "parent": 197,
      "props": {
        "id": {
          "type": "value",
          "value": "ModPlanningUX-FormField-198"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "TextArea",
      "parent": 198,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-TextArea-199"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", textAlign: \"center\" }"
        },
        "value": {
          "type": "code",
          "value": "props.planningData?.dates?.join('\\n')"
        }
      },
      "seq": 199,
      "void": true
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 196,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-div-200"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"13rem\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "react-big-calendar",
      "id": 201,
      "name": "Calendar",
      "parent": 200,
      "props": {
        "events": {
          "type": "code",
          "value": "props.planningData?.dates || []"
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Calendar-201"
        },
        "localizer": {
          "type": "code",
          "value": "props.calendarLocalizer"
        },
        "min": {
          "type": "code",
          "value": "new Date()"
        },
        "onNavigate": {
          "type": "code",
          "value": "props.onCalendarNavigate"
        },
        "views": {
          "type": "code",
          "value": "[\"month\"]"
        }
      },
      "seq": 201,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "Radio",
      "parent": 156,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.planningData?.scheduleType === \"day\""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Radio-202"
        },
        "label": {
          "type": "value",
          "value": "ทำซ้ำ",
          "valueEN": "Repeat"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRadio"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\", fontSize: \".92857143em\"}"
        },
        "value": {
          "type": "value",
          "value": "day"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "Radio",
      "parent": 163,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.planningData?.scheduleType === \"week_days\""
        },
        "id": {
          "type": "value",
          "value": "ModPlanningUX-Radio-203"
        },
        "label": {
          "type": "value",
          "value": "ในวัน",
          "valueEN": "On the day"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRadio"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"80px\", maxWidth: \"80px\", fontSize: \".92857143em\"}"
        },
        "value": {
          "type": "value",
          "value": "week_days"
        }
      },
      "seq": 165,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "ModPlanningUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
